const DEFAULT_FRONT = '#94a3b8';
const DEFAULT_BACK = '#758499';
const DEFAULT_SHADOW = '#8594a9';

function clampChannel(value) {
  return Math.max(0, Math.min(255, Math.round(value)));
}

function adjustColor(hex, amount) {
  const normalized = String(hex || '').replace('#', '');
  if (!/^[0-9a-fA-F]{6}$/.test(normalized)) {
    return hex;
  }

  const num = parseInt(normalized, 16);
  const r = clampChannel((num >> 16) + amount);
  const g = clampChannel(((num >> 8) & 0xff) + amount);
  const b = clampChannel((num & 0xff) + amount);

  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Lovable folder badge overlay (exact):
 * <div class="absolute inset-0 flex items-center justify-center"
 *      style="padding-top: 10.56px; font-size: 36.96px; line-height: 1;">…</div>
 * on an 88×72.16 wrapper (padding-top = 12% of width, font-size = 42% of width).
 *
 * @param {{ color?: string|null, emoji?: string|null, size?: number }} [options]
 */
export default function folderSvg(options = {}) {
  const color = options.color || null;
  const emoji = options.emoji || null;
  const size = options.size || 88;

  const front = color || DEFAULT_FRONT;
  const back = color ? adjustColor(color, -25) : DEFAULT_BACK;
  const shadow = color ? adjustColor(color, -12) : DEFAULT_SHADOW;
  const height = Number((size * 0.82).toFixed(2));
  const emojiSize = Number((size * 0.42).toFixed(2));
  const emojiPad = Number((size * 0.12).toFixed(2));

  const emojiHtml = emoji
    ? `<div class="folder-icon-emoji" style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;padding-top:${emojiPad}px;font-size:${emojiSize}px;line-height:1;pointer-events:none;">${escapeHtml(emoji)}</div>`
    : '';

  return `
    <div class="folder-icon-preview" style="position:relative;width:${size}px;height:${height}px;pointer-events:none;">
      <svg viewBox="0 0 100 82" width="100%" height="100%" aria-hidden="true" preserveAspectRatio="xMidYMid meet">
        <path d="M4 14 Q4 8 10 8 L36 8 Q40 8 42 11 L46 17 L90 17 Q96 17 96 23 L96 70 Q96 76 90 76 L10 76 Q4 76 4 70 Z" fill="${back}"></path>
        <path d="M4 24 Q4 18 10 18 L90 18 Q96 18 96 24 L96 70 Q96 76 90 76 L10 76 Q4 76 4 70 Z" fill="${front}"></path>
        <path d="M4 24 Q4 18 10 18 L90 18 Q96 18 96 24 L96 26 L4 26 Z" fill="${shadow}" opacity="0.55"></path>
      </svg>
      ${emojiHtml}
    </div>`;
}
